// extracted by mini-css-extract-plugin
export default {"lastUpdated":"lastUpdated---fq8Sa","lastUpdatedUser":"lastUpdatedUser---lgtUD"};